module.exports = __webpack_public_path__ + "static/media/app_gallery_badge_en_color_40.6e61d48f.svg";